export default __webpack_public_path__ + "static/xywav_logo-7f5b4e9b6ce218ee9c78e2ebf7809055.svg";